"use client";

import React, { useMemo, useState } from "react";
import {
  DynamicLandingPageData
} from "@/types/dto/landing-page/landing-page";
import { Dialog, Stack } from "@mui/material";
import DynamicLandingPageComponent
  from "@/components/landing-page/dynamic-landing-page-component/dynamic-landing-page-component";
import dynamicLandingPageModulesFactory
  from "@/factories/landing-page/dynamic-landing-page/dynamic-landing-page-modules-factory";
import RequestAQuoteSection from "@/components/forms/request-a-quote/request-a-quote-section";
import { Tour } from "@/types/dto/tours/tour";
import useScrollLock from "@/hooks/scroll-lock/use-scroll-lock";
// eslint-disable-next-line import/no-named-as-default
import useUserGroups from "@/hooks/login/useUserGroups";
import DataLayer from "@/components/data-layer/data-layer";

const DynamicLandingPageLayout = ({
  contentBlocks,
  seoMetaData
}: DynamicLandingPageData) => {
  const { isAgent } = useUserGroups();

  const dataLayer = useMemo(
    () => ({
      event: "dataLayerPush",
      pageInformation: {
        pageGroupType: "Landing Page",
        pageSubgroupType: seoMetaData?.pageSubgroupType ?? "",
        isAgent: isAgent.toString()
      }
    }),
    [seoMetaData?.pageSubgroupType, isAgent]
  );

  // state for request a quote modal
  const [raqFormOpen, setRaqFormOpen] = useState<boolean>(false);
  const [openTour, setOpenTour] = useState<Tour | null>(null);

  const handleClickOpen = (tour: Tour) => {
    setRaqFormOpen(true);
    setOpenTour(tour);
  };

  const handleClose = () => {
    setRaqFormOpen(false);
    setOpenTour(null);
  };

  useScrollLock(raqFormOpen);

  const modules = dynamicLandingPageModulesFactory(contentBlocks, {
    openRequestAQuote: handleClickOpen
  });
  
  return (
    <Stack>
      {/* Map content blocks to proper component */}
      {modules.map(({ id, type, props }, index) => (
        <DynamicLandingPageComponent
          key={id}
          type={type}
          props={props}
          moduleId={id}
          moduleRankingPosition={(index + 1).toString()}
        />
      ))}

      <Dialog open={raqFormOpen} onClose={handleClose} maxWidth="md">
        <RequestAQuoteSection
          handleClose={handleClose}
          tourId={openTour?.id}
          landingPageId={openTour?.id}
        />
      </Dialog>
      <DataLayer data={dataLayer} />
    </Stack>
  );
};

export default DynamicLandingPageLayout;